import React from 'react';
import { Alert } from 'react-bootstrap';

export const getMsgAlertStatusPedido = (pedido) => {
    const result = {};
    switch (pedido.idstatus) {

        case 1:
            result.msg = <Alert variant='secondary'>Aguardando Pagamento</Alert>;
            break;

        case 2:
            result.msg = <Alert variant='success'>Pago</Alert>;
            break;

        case 3:
            result.msg = <Alert variant='danger'>Cancelado por Inatividade</Alert>;
            break;

        case 7:
            result.msg = <Alert variant='danger'>Excluido</Alert>;
            break;

        case 6:
            result.msg = <Alert variant='info'>Cortesia</Alert>;
            break;

        case 10:
            result.msg = <Alert variant='danger'>Cancelado pelo Sistema</Alert>;
            break;
    
        default:
            result.msg = <Alert variant='info'>Status não configurado</Alert>;
            break;
    }
    return result;
}